var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap gap-2"},[_c('div',{class:[
            'flex gap-2 items-center transition-all shrink-0',
            _vm.variant === 'default'
                ? ['backdrop-blur-sm p-2 rounded-full overflow-hidden group max-w-[32px] hover:max-w-max']
                : _vm.variant === 'alwaysVisible'
                    ? ['backdrop-blur-sm p-2 rounded-full overflow-hidden max-w-max']
                    : '' // inline → no bg/padding
        ]},[_c('div',{class:[
                _vm.variant === 'inline' ? _vm.textColor : 'text-white'
            ]},[_c('svg-vue',{class:[
                    _vm.variant === 'alwaysVisible' || _vm.variant === 'inline' ? 'h-3.5' : 'h-4'
                ],attrs:{"icon":_vm.icon}})],1),_vm._v(" "),_c('div',{class:[
                _vm.variant === 'default'
                    ? 'text-white text-[10px] opacity-0 transition group-hover:opacity-100 break-keep shrink-0'
                    : _vm.variant === 'alwaysVisible'
                        ? 'text-white text-[10px] break-keep shrink-0'
                        : _vm.textColor + ' text-[10px] break-keep shrink-0' // inline always visible
            ]},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }